import {ARCHIVED_MEMBERS_REQUEST, ARCHIVED_MEMBERS_SUCCESS,ARCHIVED_MEMBERS_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const ArchivedMembersAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: ARCHIVED_MEMBERS_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_deactivated_members?vendorId=${data.vendorId}&pageNumber=${data.pageNumber}&pageSize=10&search=${data.search}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: ARCHIVED_MEMBERS_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const loadAllDetailsPre = (data) => {
    return {
      type: ARCHIVED_MEMBERS_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  